// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"C0-z","sponsoredTooltipWrapper":"D0-z","sponsoredTooltip":"E0-z","newCard":"F0-z"};